import React from 'react'

import FormOption from './FormOption'

const Checkbox = props => <FormOption type="checkbox" {...props} />

Checkbox.displayName = 'Checkbox'

export default Checkbox
